import React from 'react';
import Apps from '../../../../assets/svg/apps';
import List from '../../../../assets/svg/list';

const PhotoViewControl = ({ changeView, activeView }) => (
  <div className='flex-1 flex-rows' style={{ alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer' }}>
    <div style={{ marginRight: 16 }} onClick={() => changeView('grid')}>
      <Apps fill={activeView === 'grid' ? '#2E2E39' : '#A4AFB7'} />
    </div>
    <div onClick={() => changeView('list')}>
      <List fill={activeView === 'list' ? '#2E2E39' : '#A4AFB7'} />
    </div>
  </div>
);

export default PhotoViewControl;
